module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "container block-primary"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("นโยบายความเป็นส่วนตัว")]), _vm._v(" "), _c('h2', {
    staticClass: "page-title"
  }, [_vm._v("รายละเอียด")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07b826d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privacy.vue
// module id = 1081
// module chunks = 1